import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, STATUS_LABELS } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function History() {
  const { user } = useAuth();
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    const q = user.role === "helper" ? "mine=helper" : "mine=client";
    api.get(`/tasks?${q}`).then((r) => setTasks(r.data));
  }, [user.role]);

  return (
    <div className="max-w-4xl mx-auto space-y-4">
      <h1 className="text-3xl md:text-4xl font-heading font-black text-navy">Historique</h1>
      {tasks.length === 0 ? (
        <div className="card-surface p-8 text-center text-[#475569]">Aucune tâche pour l'instant.</div>
      ) : (
        <div className="space-y-3">
          {tasks.map((t) => {
            const s = STATUS_LABELS[t.status];
            return (
              <Link key={t.id} to={`/tasks/${t.id}`} className="card-interactive p-4 flex items-center gap-4" data-testid={`history-${t.id}`}>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className={`chip ${s.color}`}>{s.fr}</span>
                    {t.urgent && <span className="chip-lime">Urgent</span>}
                  </div>
                  <h3 className="font-heading font-black text-navy text-lg mt-1">{t.title}</h3>
                  <div className="text-sm text-[#475569]">{t.area} · {new Date(t.created_at).toLocaleDateString()}</div>
                </div>
                <div className="text-right">
                  <div className="text-xs font-bold uppercase text-[#94A3B8]">{user.role === "helper" ? "Reçu" : "Payé"}</div>
                  <div className="font-heading font-black text-xl text-navy">
                    {(user.role === "helper" ? t.helper_subtotal : t.total).toFixed(2)} $
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
